import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ComponentSettings,
    ComponentSettingsChartDataQueriesTable,
    RendererFilter,
    NewBlockContextType,
} from '@report-content';
import { AssocArray, YNValues } from 'tools/types';

export class BlockFactoryManageFilters extends AbstractBlockFactory<ComponentSettingsManageFilters> {
    public getNewBlock({}: NewBlockContextType): BlockType<ComponentSettingsManageFilters> {
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: -1,
                datasetRendererBlockId: -1,
                datasetRendererComponentId: -1,
                displayOrder: 0,
                internalName: 'manage_filters',
                settings: {
                    uid: 'manage_filters',
                    title: '',
                    height: 600,
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    is_collapsed_ind: 'N',
                    include_in_email: 'Y',
                    include_in_email_attachment: 'Y',
                    internal_name: 'manage_filters',
                    fields: [],
                    isOnCreation: false,
                    groupFilter: { operator: 'AND', rules: [] },
                    dataQueries: {
                        skip: true,
                    },
                    filterPosition: 'top',
                    only_display_relevant_values: 'N',
                },
            },
            displayOrder: -1,
            uid: 'manage_filters',
        };
    }
}

export interface ComponentSettingsManageFiltersDataQueries {
    [key: string]: ComponentSettingsChartDataQueriesTable | boolean;
    skip: boolean;
}

// One value row for a filter. Reference names are dynamic (dataset column names), so keys can't be
// enumerated statically, but every row is guaranteed a raw `[reference_name]` and a
// `${reference_name}-formatted` (label) entry.
export interface ManageFiltersFilterValueRow {
    [key: string]: string | Array<string>;
}

// Keyed by filter reference_name.
export type ManageFiltersDataResults = Record<string, Array<ManageFiltersFilterValueRow>>;

export interface ManageFiltersInitialDataResponse {
    dataResults: ManageFiltersDataResults;
}

// Keyed by filter reference_name; values are the allowed options given the current filter selections.
export interface ManageFiltersRelevantValuesResponse {
    values: Record<string, Array<string | number>>;
}

export interface ComponentSettingsManageFilters extends ComponentSettings {
    uid: string;
    fields: Array<RendererFilter>;
    requestParams?: AssocArray<any>; // TODO
    dataQueries: ComponentSettingsManageFiltersDataQueries;
    filterPosition: 'top' | 'left' | 'right';
    only_display_relevant_values?: YNValues;
}
